import { BrandStatus } from '@innovationdepartment/proxima-sdk-axios';
import _ from 'lodash';
import type { Brand, BrandStore } from 'types/stores/brand-store';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

const emptyState = {
  brandId: '',
  name: '',
  domain: '',
  status: BrandStatus.Active,
  createdAt: undefined,
  isManaged: undefined,
  dojoBrandId: undefined,
  category: undefined
};
const allowedKeys = Object.keys(emptyState);
const persistKeyName = 'brand-store';

const useBrandStore = create<BrandStore>()(
  persist(
    set => ({
      brand: emptyState,
      clearBrandStore: () => set({ brand: emptyState }),
      updateBrandStore: (brand: Brand, clear = false) => {
        const pickKeys = _.pick(brand, allowedKeys);
        const selectedBrand = { ...pickKeys };

        if (clear) return set({ brand: selectedBrand as BrandStore['brand'] });

        return set(prevState => ({ brand: { ...prevState.brand, ...selectedBrand } }));
      }
    }),
    { name: persistKeyName, storage: createJSONStorage(() => window.sessionStorage) }
  )
);

export default useBrandStore;
